import styled from "styled-components";
import { theme } from "theme";

export const BackButton = styled.div`
  margin-bottom: ${theme.spacing(2)};

  .back-btn {
    color: ${theme.palette.text.primary} !important;
    gap: ${theme.spacing(3)};
  }

  h5,
  h4,
  h3 {
    margin-bottom: 0 !important;
  }
`;
